export default [{
    path: 'system',
    redirect: '/system/roleIndex',
    children: [{
        path: '/system/roleIndex',
        meta: {
            title: '角色管理',
            name: 'role',
        },
        components: {
            mains:() => import('../views/system/index.vue')
        }
    }, {
        path: '/system/addRole',
        meta: {
            title: '新增角色'
        },
        components: {
            mains:() => import('../views/system/add.vue')
        }
    }, {
        path: '/system/editRole',
        meta: {
            title: '编辑角色'
        },
        components: {
            mains:() => import('../views/system/add.vue')
        }
    }, {
        path: '/system/userIndex',

        meta: {
            title: '系统用户管理',
            name: 'system_user',
        },
        components: {
            mains:() => import('../views/system/userIndex.vue')
        }
    }, {
        path: '/system/addUser',
        meta: {
            title: '新增用户'
        },
        components: {
            mains:() => import('../views/system/addUser.vue')
        }
    }, {
        path: '/system/menuIndex',
        meta: {
            title: '菜单管理',
            name: 'menus',
        },
        components: {
            mains:() => import('../views/system/menuIndex.vue')
        }
    }, ]
}]